import React, { useState } from 'react';
import { imageZone, imageZoneWithImgData } from './ZonesList.types';
import { Prompt } from '../../../../components/Prompt/Prompt.component';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ZonesListItem } from './ZoneListItem/ZoneListItem.component';
import { ZoneDropArea } from './ZoneListItem/ZoneDropArea.component';

interface ZoneListProps {
  zones: imageZoneWithImgData[];
  currentZoneIndex?: number;
  onClickZone: (zone: imageZone) => void;
  onRemoveZone: (zone: imageZone) => void;
  onDropZone: (draggedZone: imageZone, targetZone: imageZone | null) => void;
}

const ZoneList: React.FC<ZoneListProps> = (props) => {
  const [zoneToBeDeleted, setZoneToBeDeleted] = useState<imageZone | undefined>(undefined);

  const handleRemoveZone = (zone: imageZone) => {
    props.onRemoveZone(zone);
    setZoneToBeDeleted(undefined);
  };

  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <ZoneDropArea zone={null} onDropZone={props.onDropZone}>
          <div style={{ height: '10px' }}></div>
        </ZoneDropArea>
        {props.zones.map((item: imageZoneWithImgData) => {
          const isActive = props.currentZoneIndex === item.zone.orderNumber;
          return (
            <React.Fragment key={item.zone.tempId}>
              <ZonesListItem
                zone={item.zone}
                wholeImageData={item.wholeImageData}
                isActive={isActive}
                onClickZone={props.onClickZone}
                onDeleteButtonClick={setZoneToBeDeleted}
                onDropZone={props.onDropZone}
              />
            </React.Fragment>
          );
        })}
      </DndProvider>
      {zoneToBeDeleted && (
        <Prompt
          type="confirmation"
          open={true}
          mainText={`Czy na pewno chcesz usunąć obszar: ${zoneToBeDeleted.orderNumber + 1}?`}
          mainActionButtonText="TAK"
          onConfirm={() => handleRemoveZone(zoneToBeDeleted)}
          onCancel={() => setZoneToBeDeleted(undefined)}
        />
      )}
    </>
  );
};

export default React.memo(ZoneList);